import { Injectable } from '@angular/core';
import { UturuncoUtils } from '../../utils/uturuncoUtils';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Categoria } from 'src/app/model/index.model';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class CategoriaService extends BaseService<Categoria> {

    constructor(protected override http: HttpClient) {
        super(http, 'categoria');
    }

}
